import React from 'react';
import {
  DataBox,
  DataBoxBaseProps,
  DataBoxLegendProps,
} from 'src/components/molecules/DataBox';
import { ValueTickFormatter } from 'src/utils/TickFormatters';
import { useMetrics } from '../../hooks/useMetrics';
import { useKpiMetricLabelMap } from '../../hooks/useKpiMetricLabelMap';
import { NewBarGraph } from 'src/components/molecules/graphs/NewBarGraph';

const MAX_NAME_LENGTH = 20;
const campaignNameFormatter = (campaignName: string | number): string => {
  if (typeof campaignName !== 'string') {
    return campaignName.toString();
  }
  if (campaignName.length > MAX_NAME_LENGTH) {
    return `${campaignName.slice(0, MAX_NAME_LENGTH)}...`;
  }
  return campaignName;
};

export const MetricsByCampaignBarGraph: React.FC<DataBoxBaseProps> = ({
  ...props
}) => {
  const { data, isError, isLoading, dataKeys } = useMetrics('byCampaign');
  const labelMap = useKpiMetricLabelMap();

  const legendProps: DataBoxLegendProps = {
    baseLegendKeys: dataKeys.data,
    placement: 'right',
    labelMap,
  };

  return (
    <DataBox
      {...props}
      legendProps={legendProps}
      hasData={data.length > 0}
      isError={isError}
      isLoading={isLoading}>
      <NewBarGraph
        data={data}
        xAxisKey={dataKeys.xAxis}
        tooltipLabelMap={labelMap}
        stacked={false}
        yAxisFormatter={ValueTickFormatter}
        xAxisTooltipFormatter={(c) => c.toString()}
        xAxisFormatter={campaignNameFormatter}
      />
    </DataBox>
  );
};
